<app-toast-message #toast toastKey="permission-groups"></app-toast-message>
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="generic-modal-container create-user-dialog"
  (onHide)="close()"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h2>
        {{ editMode ? "Edit Product Family" : "Add a New Product Family" }}
      </h2>
      <!-- Changed title -->
    </div>
  </ng-template>

  <div class="modal-body">
    <form [formGroup]="productFamilyForm" autocomplete="off">
      <!-- Changed formGroup name -->

      <div class="form-row">
        <div class="form-group">
          <label for="name"
            >Product Family Name<span class="required">*</span></label
          >
          <input
            id="name"
            type="text"
            pInputText
            placeholder="Enter product family name"
            formControlName="name"
            [ngClass]="{
              'ng-invalid ng-dirty':
                productFamilyForm.controls['name'].invalid &&
                (productFamilyForm.controls['name'].touched ||
                  productFamilyForm.controls['name'].dirty)
            }"
          />
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button
        pButton
        type="button"
        label="Submit"
        class="p-button-warning"
        (click)="onSubmit()"
        [disabled]="!productFamilyForm.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<app-modal
  [visible]="permissionPop"
  [cancelButtonText]="'No'"
  [submitButtonText]="'Yes'"
  [header]="'Permission'"
  (onSubmit)="onSubmitPermission($event)"
  (onCancel)="onCancelPermission($event)"
>
  <div class="permission-content">
    Are you sure you want to {{ this.editMode ? "edit" : "add" }} this Product
    Family
  </div>
</app-modal>
